import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { PaysI18n } from './pays'
import { NftI18n } from './nft'
import { DiskI18n } from './disk'
import { VipInfo18n } from './vipInfo'
import { AndroidNotice18n } from './androidNotice'
import { IncomeI18n } from './income'
import { InviteI18n } from './invite'
import { JoinMeetingI18n } from './joinMeeting'
import { AccountCancellationI18n } from './accountCancellation'
import SubscriptionI18n from './subscription.js'
import IntroductionI18n from './introduction'
import PublicI18n from "./public";
import { DigitalWalletFAQI18n } from './digitalWalletFAQ';
const lng = 'zh'
let resources = {
	zh: {
		translation: {
			'open-app': '在APP内打开',
			title: '链上会 - 基于数信云的分布式智能商业应用终端',
			description: '基于分布式账本（DLT）、分布式公钥基础设施（DPKI）、分布式数字身份（DID）等技术打造以“协同、分享、建设”为核心的数据信托开放平台，实现任务驱动的分布式智能商业应用终端。',
			'app-name': '链上会',
			tip: '若无法正常跳转请先点击【立即下载】按钮',
			'btn-text': '立即下载',
			'header-tip': '请点击右上角“更多"按钮，<br/> 选择 “在浏览器中打开”',
			'pc-tip': '下载安装“链上会”，一键快速加入“链上会” <br>更多版本请前往官网',
			pcBtn1: '下载',
			pcBtn2: '取消',
			error: '网络连接失败，请稍后再试！',
			'url-error': '无效链接~',
			'vip-coupon-tip': '成为会员享用无限次高容量会议，与完整Web3功能，快来领取吧！',
			'vip-coupon-btn': '领取',
			'vip-coupon-text': '向您赠送',
			'vip-coupon-unit': '1张',
			footerLeft: '版权所有© ',
			footerRight: '.UnionDefi Labs。保留所有权利。',
			fileShare: {
				btn: '链上会App内打开文件',
				tip: '文件分享:'
			},
			friendQR: {
				btn: '链上会App内打开',
				nickName: '昵称',
				position: '职务',
				mobile: '电话',
				email: '邮箱',
				address: '地址',
			},
			...PaysI18n.zh,
			...NftI18n.zh,
			...DiskI18n.zh,
			...VipInfo18n.zh,
			...AndroidNotice18n.zh,
			...IncomeI18n.zh,
			...InviteI18n.zh,
			...JoinMeetingI18n.zh,
			...AccountCancellationI18n.zh,
			...SubscriptionI18n.zh,
			...IntroductionI18n.zh,
			...PublicI18n.zh,
			...DigitalWalletFAQI18n.zh
		},
	},
	en: {
		translation: {
			'open-app': 'Open in APP',
			title: 'ChainPal - Distributed intelligent business application terminal based on DCloud',
			description: 'Based on distributed ledger (DLT), distributed public key infrastructure (DPKI), distributed digital identity (DID) and other technologies, a data trust open platform with "collaboration, sharing, and construction" as the core is built to achieve task-driven distributed Intelligent business application terminal.',
			'app-name': 'ChainPal',
			tip: 'If you cannot jump normally, <br /> please click the【 Download 】button.',
			'btn-text': 'Download',
			'header-tip': 'Please click "more" button,<br/> Choose "open in browser"',
			'pc-tip': 'Download and install the ChainPal, one-click to quickly join the ChainPal <br> For more versions, please go to the official website',
			pcBtn1: 'Download',
			pcBtn2: 'Cancel',
			error: 'Network connection has failed, please try again later!',
			'url-error': 'Invalid link~',
			'vip-coupon-tip': 'Switch a membership to enjoy unlimeted high capacity meeting,and fully functional Web3. Receive now!',
			'vip-coupon-btn': 'Receive',
			'vip-coupon-text': 'give you',
			'vip-coupon-unit': '1',
			footerLeft: 'Copyright © ',
			footerRight: ' UnionDefi Labs. All rights reserved.',
			fileShare: {
				btn: 'Open File with ChainPal',
				tip: 'File sharing:'
			},
			friendQR: {
				btn: 'Open in App',
				nickName: 'Nickname',
				position: 'Position',
				mobile: 'Mobile',
				email: 'Email',
				address: 'Address',
			},
			...PaysI18n.en,
			...NftI18n.en,
			...DiskI18n.en,
			...VipInfo18n.en,
			...AndroidNotice18n.en,
			...IncomeI18n.en,
			...InviteI18n.en,
			...JoinMeetingI18n.en,
			...AccountCancellationI18n.en,
			...SubscriptionI18n.en,
			...IntroductionI18n.en,
			...PublicI18n.en,
			...DigitalWalletFAQI18n.en
		},
	},
}
i18n.use(initReactI18next).init({
	resources,
	lng: lng,
	fallbackLng: lng,
	interpolation: {
		escapeValue: false,
	},
})
export default i18n
